import { createAxiosInstance } from '../utils/axiosConfig';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8083/api';

// Get auth token from localStorage (for backward compatibility)
const getAuthToken = () => localStorage.getItem('token');

// Create axios instance with default config and interceptors
const addressAPI = createAxiosInstance({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
addressAPI.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const addressService = {
  // Get all addresses for a user
  getUserAddresses: async (userId) => {
    try {
      const response = await addressAPI.get(`/users/${userId}/addresses`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch addresses');
    }
  },

  // Get a specific address
  getUserAddress: async (userId, addressId) => {
    try {
      const response = await addressAPI.get(`/users/${userId}/addresses/${addressId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch address');
    }
  },

  // Add a new address
  addUserAddress: async (userId, addressData) => {
    try {
      const response = await addressAPI.post(`/users/${userId}/addresses`, addressData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to add address');
    }
  },

  // Update an existing address
  updateUserAddress: async (userId, addressId, addressData) => {
    try {
      const response = await addressAPI.put(`/users/${userId}/addresses/${addressId}`, addressData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update address');
    }
  },

  // Delete an address
  deleteUserAddress: async (userId, addressId) => {
    try {
      const response = await addressAPI.delete(`/users/${userId}/addresses/${addressId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete address');
    }
  },

  // Get default address
  getDefaultAddress: async (userId) => {
    try {
      const response = await addressAPI.get(`/users/${userId}/addresses/default`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch default address');
    }
  },

  // Set address as default
  setDefaultAddress: async (userId, addressId) => {
    try {
      const response = await addressAPI.post(`/users/${userId}/addresses/${addressId}/set-default`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to set default address');
    }
  },
};

export default addressService;